// Core Imports
import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';

import Banner from "../../assets/images/contactus/contact-banner.jpeg"

// Icons
import RoomIcon from '@mui/icons-material/Room';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

// Custom Components
import ContactForm from '../../components/ContactForm';

const ContactUsPrint = () => {
  return (
    <div>

      {/* Breadcrumb Navigation */}
      <section id="breadcrumbs" className="breadcrumbs" style={{
          backgroundImage: `url(${Banner})`,
        }}
      >
        <div className="container">
          <h1>Contact Us</h1>
          {/* <ul>
            <li><a href="./">Home</a></li>
            <li>Contact Us</li>
          </ul> */}
        </div>
      </section>

      {/* Main Contact Section */}
      <section className="entry">
        <Container>
          <h2>Get In Touch</h2>
          <h3>We are always ready to solve your problem</h3>
          <Row>

            {/* Contact Form Column */}
            {/* <Col md={9} className="position-relative">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2800.799433749425!2d167.71765667704435!3d-45.413383905319684!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa9d40e4a6f698b33%3A0x33720336da945834!2s186%20Milford%20Road%2C%20Te%20Anau%209600!5e0!3m2!1sen!2snz!4v1770677593732!5m2!1sen!2snz"
                width="100%"
                height="450"
                style={{ border: 0 }}
                title="Te Anau"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </Col> */}

            {/* Contact Information Column */}
            <Col md={12} xs={12} className="contact-info my-auto">

              {/* Address */}
              <div className="icon mt-unset"><RoomIcon /></div>
              <h4>Address</h4>
              <p>
                186 Milford Road<br />
                Te Anau 9600<br />
                Southland<br />
                New Zealand
              </p>

              {/* Email */}
              <div className="icon"><EmailIcon /></div>
              <h4>Email</h4>
              <p>
                <a href="mailto:office@southernalpsdp.co.nz">office@southernalpsdp.co.nz</a>
              </p>

              {/* Phone */}
              <div className="icon"><PhoneIcon /></div>
              <h4>Phone</h4>
              <p>
                <a href="tel:+64 03/660 4888">+64 03/660 4888</a>
              </p>

            </Col>
          </Row>
        </Container>
      </section>

    </div>
  );
};

export default ContactUsPrint;
